<template>
  <Card flat class="nch--post">
    <div class="nch--post-content">
      <a
        class="post-title"
        :href="`/blog/post/${post.translation.slug}`"
        :title="post.translation.title"
      >{{ post.translation.title }}</a>
      <div class="meta">
        {{ $moment(post.created_at).format('LL') }} &middot; {{ post.author.name }}
      </div>
      <p v-html="post.translation.meta_description"></p>
      <div class="info">
        <i class="mdi mdi-eye"></i>
        <span>
          {{ post.views || 0 }}
          <template v-if="!xs">
            {{ $t('blog.posts.views') }}
          </template>
        </span>
        <i class="mdi mdi-chat"></i>
        <span>
          {{ post.comments_count || 0 }}
          <template v-if="!xs">
            {{ $t('blog.comments.title') }}
          </template>
        </span>
      </div>
    </div>
    <div
      v-if="post.thumbUrl"
      class="nch-post-image"
      :style="{backgroundImage: `url('${post.thumbUrl}')`}"
    ></div>
  </Card>
</template>
<script>
import Card from '../common/Card';
import Button from '../common/Button';
import responsive from '../../mixins/responsive';

export default {
  name: 'Post',
  components: {
    Card,
    Button,
  },
  mixins: [
    responsive,
  ],
  props: {
    value: {
      type: Object,
      required: true,
      description: 'Post object',
    },
  },
  computed: {
    post() {
      return this.value;
    },
  },
};
</script>

<style scoped>
.nch--post{
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.nch--post-content{
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  flex-grow: 1;
  margin: .5rem 0;
  height: 100%;
  justify-content: space-between;
}
.nch-post-image{
  min-width: 182px;
  max-width: 182px;
  height: 100px;
  margin: 2rem 0.3rem 0.3rem 1.5rem;
  border-radius: 5px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.post-title{
  font-size: 1.4rem;
  color: var(--blog-text);
  font-weight: 600;
}
.post-title:hover{
  cursor: pointer;
  color: var(--blog-link);
}
.info span{
  margin-right: 5px;
}
.meta{
  margin-bottom: 1rem;
}
@media (max-width: 1100px) {
  .nch--post {
    flex-wrap: wrap-reverse;
  }
  .nch--post-content {
    height: unset;
  }
  .nch-post-image {
    width: 100%;
  }
}
</style>
